export default function DeleteAllButton() {
  return (
    <button className="bg-primary hover:bg-primary/80 mx-auto flex rounded border-0 px-8 py-2 text-lg text-white focus:outline-none">
      DeleteAllBtn
    </button>
  );
}
